import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { BlockVideoPlayer } from "../../../shared/components/BlockVideoPlayer/BlockVideoPlayer";
import type { IVideoStandardProps } from "./VideoStandard.props";

export const VideoStandard = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  source,
  url,
  videoBanner,
}: IVideoStandardProps) => (
  <BlockContainer anchorId={anchorId} parentClass={parentClass} spacing={spacing}>
    <div className="flex flex-col gap-10 md:gap-14">
      <BlockCommonContent
        alignment={alignment}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingLevel="h2"
      />
      {buttons?.length ? <BlockActions actions={buttons} alignment={alignment} /> : null}
      <BlockVideoPlayer banner={videoBanner} source={source} title={heading ?? ""} url={url} />
    </div>
  </BlockContainer>
);

VideoStandard.displayName = "Video::VideoStandard";
